<mat-accordion>
  <ng-container
    *ngFor="let expantionPanel of input.ExpansionPanels"
    [dynamicWidget]="expantionPanel"
    [context]="context"
  ></ng-container>
</mat-accordion>
